import { render, staticRenderFns } from "./ChannelsPanel.vue?vue&type=template&id=c80a54dc&scoped=true"
import script from "./ChannelsPanel.vue?vue&type=script&lang=js"
export * from "./ChannelsPanel.vue?vue&type=script&lang=js"
import style0 from "./ChannelsPanel.vue?vue&type=style&index=0&id=c80a54dc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80a54dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c80a54dc')) {
      api.createRecord('c80a54dc', component.options)
    } else {
      api.reload('c80a54dc', component.options)
    }
    module.hot.accept("./ChannelsPanel.vue?vue&type=template&id=c80a54dc&scoped=true", function () {
      api.rerender('c80a54dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Settings/Tenants/ChannelsPanel.vue"
export default component.exports